import { createStore } from 'redux';
import * as actionType from "./actions";

const reducer = (state, action) => {
	switch(action.type){
		case actionType.UPDATE_ASSET:
			return {...state, event: actionType.UPDATE_ASSET, asset: action.asset};
		case actionType.PLAYER_EVENT:
			return {...state, event: actionType.PLAYER_EVENT, player_event: action.player_event};
		case actionType.FILTERED:
			return {...state, event: actionType.FILTERED};
		case actionType.SCROLL:
			return {...state, event: actionType.SCROLL};
		case actionType.CURRENT_VIDEO:
			return {...state, event: actionType.CURRENT_VIDEO};
		case actionType.CLOSE_MODAL:
			return {...state, event: actionType.CLOSE_MODAL};
		case actionType.UPDATE_BREADCRUMBS:
			return {...state, event: actionType.UPDATE_BREADCRUMBS, ambassador: action.ambassador, asset: action.asset};
		case actionType.UPDATE_PRODUCT_MODAL:
			return {...state, event: actionType.UPDATE_PRODUCT_MODAL, product_modal: action.product_modal, video: action.video};
		default:
			return state;

	}
};

export default createStore(reducer,{ video:[], video_event: "initial", event: '' });